/**
 * Работа с файлами
 *
 */

;
window.FK = (() => {
	"use strict";

	if (!window.PARAMS) {
		console.error('[FK] PARAMS.js не загружен до FileKit.js');
	}
	if (!window.jQuery) {
		console.error('[FK] jQuery не загружен до FileKit.js');
	}
	if (!window.MoK) {
		console.error('[FK] ModalsKit.js не загружен до FileKit.js');
	}
	if (!window.aAlert) {
		console.error('[FK] aAlert не загружен до FileKit.js');
	}
	if (!window.aConfirm) {
		console.error('[FK] aConfirm не загружен до FileKit.js');
	}

	const FileHelpers = {
		/**
		 * Форматирует размер файла в человекочитаемый вид
		 */
		formatFileSize(bytes) {
			if (!bytes || bytes === 0)
				return '0 Кб';
			const kb = (bytes / 1024).toFixed(1);
			return `${kb} Кб`;
		},

		/**
		 * Форматирует размер файла
		 * @param {type} a
		 * @param {type} b
		 * @returns {String}
		 */
		formatBytes(a, b) {
			if (0 == a) {
				return "0 байт";
			}

			var c = 1024, d = b || 2, e = ['байт', 'Kб', 'Мб', 'Гб', 'Тб'], f = Math.floor(Math.log(a) / Math.log(c));
			return parseFloat((a / Math.pow(c, f)).toFixed(d)) + " " + e[f]
		},

		getStrFileSize(size) {
			return `[${FileHelpers.formatFileSize(size)}]`;
		},

		/**
		 * Узнать расширение файла
		 * @param {type} name - полное название файла в строковом формате
		 * @returns {FileHelpers=>#5.FileHelpers.getFileInfoFromName.result}
		 */
		getFileExtension(name) {
			const re = /(?:\.([^.]+))?$/;
			let ext = re.exec(name)[1].toLowerCase();
			let result = {
				ext: ext,
				type: void 0,
				gosKeyAllowed: false,
				fileExtChange: false
			};
			let type = null;
			if (ext === "jpeg") {
				ext = "jpg";
			}
			switch (ext) {
				case "docx":
					type = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
					break;
				case "xlsx":
					type = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
					break;
				case "pdf":
					type = "application/pdf";
					break;
				case "png":
					type = "image/png";
					break;
				case "txt":
				case "html":
					type = "text/plain";
					break;
				case "jpeg":
				case "jpg":
					type = "image/jpeg";
					break;
				case "zip":
					type = "application/zip";
					break;
				case "rar":
					type = "application/rar";
					break;
				default:
					type = null;
					break;
			}
			result.type = type;
			result.gosKeyAllowed = PARAMS.goskey_allowed_ext.includes(ext) || PARAMS.goskey_allowed_ext_for_change.includes(ext);
			result.fileExtChange = PARAMS.goskey_allowed_ext_for_change.includes(ext);
			return result;
		},

		/**
		 * Узнать допустимые расширения файлов
		 */
		getAcceptableFileExtension(useDot = false, concatenate = false) {
			if (PARAMS.isUseGosKey) {
				let ext = PARAMS.goskey_allowed_ext;

				if (PARAMS.goskey_allowed_ext_for_change.length > 0) {
					ext = [...ext, PARAMS.goskey_allowed_ext_for_change];
				}
				if (useDot) {
					ext = ext.map(e => "." + e);
				}
				if (concatenate) {
					ext = ext.join(", ");
				}

				return ext;
			} else {
				let ext = PARAMS.valid_file_extensions;

				if (useDot) {
					ext = ext.map(e => "." + e);
				}
				if (concatenate) {
					ext = ext.join(", ");
				}

				return ext;
			}
		},


		/**
		 * Обновление состояния Alpine.js хранилища для синхронизации файлов.
		 * Вызывается после изменений в списке файлов (поворот, удаление), чтобы Alpine-компоненты
		 * на странице (например, счетчики или условия показа кнопок) обновились.
		 *
		 * @param {HTMLElement|jQuery} inp - DOM-элемент (или jQuery-объект), внутри которого ищется .fileform__wrapper.
		 */
		updateAlpineStorage(inp) {
			if (typeof syncFilesToStore !== 'function')
				return;
			if (inp?.jquery)
				inp = inp[0];

			const wrapper = findParentByClassName(inp, 'fileform__wrapper');
			if (!wrapper)
				return;

			syncFilesToStore(wrapper);
		}
	};

	const videoHelpers = {
		extensions: [
			'avi', 'divx', 'flv', 'm4v', 'mkv', 'mov',
			'mp4', 'mpeg', 'mpg', 'ogm', 'ogv', 'ogx',
			'rm', 'rmvb', 'smil', 'webm', 'wmv', 'xvid'
		],

		/**
		 * Проверка файла на видео расширение
		 * @param {string} filename - имя файла
		 * @returns {boolean} true если файл является видео
		 */
		isVideoFile(filename) {
			const ext = filename.split('.').pop().toLowerCase();
			return this.extensions.includes(ext);
		},

		/**
		 * Получить список допустимых видео расширений
		 * @param {boolean} withDot - добавлять ли точку перед расширением
		 * @returns {string[]} массив расширений
		 */
		getVideoExtensions(withDot = false) {
			return withDot ? this.extensions.map(ext => '.' + ext) : extensions;
		},
	}

	/**
	  * FileUploadKit
	* 1. Транспортный слой - только HTTP-запросы
	* 2. Слой Очереди загрузки - UploadQueue
	* 3. UI-слой - DOM
	* 4. Слой форм и обработчиков - fileDrop, fileChange, fileOpen
	 */
	const FileUploadKit = (() => {
		const CONFIG = {
			MAX_FILE_SIZE_MB: 25,
			MAX_BATCH_SIZE_MB: 50,
			TIMEOUT_MS: 30000,
			API_URL: 'fileUpload'
		};

		const STATUS = {
			PENDING: 'pending',
			LOADING: 'loading',
			DONE: 'done',
			ERROR: 'error'
		};

		/**
		 * Транспортный слой - только HTTP-запросы
		 */
		const Transport_Layer = {
			/**
			 * Загрузка файлов через XMLHttpRequest. (надо отслеживать прогресс)
			 * Принимает либо готовый FormData, либо файлы + опции.
			 */
			async upload(source, options = {}) {
				const {
					url = 'fileUpload',
					fields = {},
					isImage = false,
					isPdf = false,
					toWebp = false,
					onProgress,
					timeout = 30000
				} = options;

				const isFormData = typeof FormData !== 'undefined' && source instanceof FormData;
				const formData = isFormData ? source : new FormData();

				if (!isFormData) {
					if (toWebp) {
						formData.append('toWebp', 'true');
					} else if (isImage) {
						formData.append('img', 'true');
					}

					if (isPdf) {
						formData.append('pdf', 'true');
					}

					for (const [key, value] of Object.entries(fields)) {
						if (value !== undefined && value !== null) {
							formData.append(key, value);
						}
					}

					const files = source instanceof File ? [source] : Array.from(source || []);

					files.forEach((file, index) => {
						formData.append(index, file);
					});
				}

				try {
					const data = await new Promise((resolve, reject) => {
						const xhr = new XMLHttpRequest();

						xhr.open('POST', url, true);
						xhr.timeout = timeout;
						xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

						if (typeof onProgress === 'function') {
							xhr.upload.onprogress = (e) => {
								if (!e.lengthComputable) {
									return
								};

								onProgress({
									loaded: e.loaded,
									total: e.total,
									percent: Math.round((e.loaded / e.total) * 100)
								});
							};
						}

						xhr.onload = () => {
							if (xhr.status >= 200 && xhr.status < 300) {
								try {
									resolve(xhr.responseText ? JSON.parse(xhr.responseText) : []);
								} catch (e) {
									reject(new Error('Некорректный JSON'));
								}
							} else {
								reject(new Error(`HTTP ${xhr.status}`));
							}
						};

						xhr.onerror = () => reject(new Error('Ошибка сети'));
						xhr.ontimeout = () => reject(new Error('Таймаут загрузки'));

						xhr.send(formData);
					});

					return { success: true, data };
				} catch (e) {
					return { success: false, error: e.message || 'Ошибка загрузки файла' };
				}
			}
		};

		/**
		 * Слой Очереди загрузки - UploadQueue
		 */
		const Queue_Layer = {

		};

		/**
		 * UI-слой - DOM
		 * чтение/поддержка DOM-представления
		 */
		const UI_Layer = {
			/**
			 * Переиндексация ВСЕХ списков файлов на странице.
			 * Обновляет атрибуты name у скрытых input'ов, чтобы они корректно отправлялись на сервер массивами.
			 * Также скрывает/показывает кнопку загрузки в зависимости от лимита.
			 */
			reindexAll() {
				$('.filelist').each(function (n, el) {
					UI_Layer.reindex(el);
				});
			},

			/**
			 * Переиндексация конкретного списка файлов.
			 * Критически важная функция: она переназначает атрибуты name у hidden input'ов (например, "files_0", "files_1"),
			 * чтобы при отправке формы бэкенд получил корректный массив. Также удаляет "лишние" файлы, если их больше лимита,
			 * и добавляет dummy-инпуты для пустых слотов.
			 *
			 * @param {HTMLElement} filelist - DOM-элемент контейнера списка (.filelist).
			 */
			reindex(filelist) {
				var doc_type = $(filelist).attr('data-doc-type');
				var is_array = $(filelist).attr('data-is-array');
				var size = $(filelist).attr('data-size');
				var is_imglist = $(filelist).hasClass("imglist");

				var n = (size > 1 ? "_" : "") + doc_type + (is_array ? '[]' : '');
				var last = -1;
				$(".attfile", filelist).each(function (i, e) {
					last = i;
					var name = (size > 1 ? i : "") + n;
					if (i <= size - 1) {
						// устанавливаем name файлов для формы
						$("input[type=hidden]", e).attr("name", name);

						if (is_imglist) {
							$($("input[type=hidden]", e)[1]).attr("name", "rotate_" + name);
							$($("input[type=hidden]", e)[2]).attr("name", "hid_" + name);
						} else {
							// Удаляем пустышку по признаку отсутствия value и data-type
							$("input[type=hidden]", e).filter(function () {
								return !this.value && !$(this).attr('data-type');
							}).remove();

							// Присваиваем имя hid-инпуту, находя его по data-type
							var $hid = $("input[type=hidden][data-type='hid']", e);
							if ($hid.length) {
								$hid.attr("name", "hid_" + name);
							}
						}
					} else {
						$("input[type=hidden]", e).closest('.attfile').remove();
					}
				});
				$('.dummy', filelist).remove();

				if (last >= size) {
					//переполнение
					aAlert("Максимальное количество файлов: " + size);
				}
				for (var i = last + 1; i < size; i++) {
					var dummy = $("<input class='dummy' type='hidden'>");
					$(dummy).attr("name", (size > 1 ? i : '') + n);
					dummy.appendTo(filelist);
					if (is_imglist) {
						var dummy_rot = $("<input class='dummy' type='hidden'>");
						$(dummy_rot).attr("name", "rotate_" + i + n);
						dummy_rot.appendTo(filelist);
					}
				}
				var filebody = findParentByClassName(filelist, 'filebody');
				if (filebody) {
					if (last > -1) {
						$(".btntitle", filebody).hide();
						$(filebody).addClass("completed");
					} else {
						$(".btntitle", filebody).show();
						$(filebody).removeClass("completed");
					}
				}
				FileHelpers.updateAlpineStorage(filelist);
			},

			/**
			 * Количество загруженных файлов
			 * @param {*} el
			 * @returns
			 */
			getLoadedFilesCount(el) {
				return $(".attfile input[value][data-type='id']:not([value=''])", el).length;
			},

			/**
			 * Сколько максимально можем загрузить
			 * @param {*} el
			 * @returns
			 */
			getFormMaxSize(el) {
				return parseInt(el.dataset.size);
			},

		};

		/**
		 * Слой форм и обработчиков - fileDrop, fileChange, fileOpen
		 * операции/обработчики событий
		 */
		const Forms_Layer = {
			/**
			 * Проверяет максимальное ли количество файлов загружено и если да то выводит предупреждение.
			 * используется только в change
			 * @param {*} inp
			 * @returns
			 */
			isMaxFiles(inp) {
				var fileform = findParentByClassName(inp, 'fileform');
				var el = $(".filelist", fileform)[0];
				const loadedFilesCout = UI_Layer.getLoadedFilesCount(el);
				var maxSize = UI_Layer.getFormMaxSize(el);
				var left_load = maxSize - loadedFilesCout;
				var newLoadCount = inp.files.length;
				if (newLoadCount > left_load) {
					aAlert("Максимум " + maxSize + " файлов, осталось " + left_load + " файлов.");
					return true;
				}
				return false;
			},
			/**
			 * Поворот изображения на 90 градусов по часовой стрелке (если право) и на 90 градусов против часовой стрелки (если лево).
			 * Обновляет CSS-transform для превью и значение скрытого input[name^='rotate'].
			 * lecacy
			 *
			 * @param {HTMLElement} inp - Кнопка поворота, по которой кликнули.
			 */
			rotate(inp, side) {
				const SIDES = ['left', 'right'];
				if (!SIDES.includes(side)) {
					console.error("такой стороны нет");
					return;
				}

				const attfile = findParentByClassName(inp, 'attfile');
				const pic = $(".pic", attfile)[0];

				let rotate_val = parseInt($("input[name^='rotate']", attfile).val());
				if (isNaN(rotate_val)) {
					rotate_val = 0;
				}

				let rotate_init_val = parseInt($("input[name^='rotate']", attfile).attr("data-val"));
				if (isNaN(rotate_init_val)) {
					rotate_init_val = 0;
				}

				const leftSide = 270; // поворот влево
				const rightSide = 90; // поворот вправо

				const targetSide = side === "left" ? leftSide : rightSide;

				var deg = (rotate_val + targetSide) % 360;
				var rotate = (360 + deg - rotate_init_val) % 360;
				$("input[name^='rotate']", attfile).val(deg);
				pic.style.transform = "rotate(" + rotate + "deg)";
				FileHelpers.updateAlpineStorage(inp);
			},
			/**
			 * Удаление файла из списка.
			 * Если файл новый (только что загружен, класс "new") — удаляет DOM-элемент полностью.
			 * Если файл существующий (уже был на сервере) — очищает скрытый input и добавляет класс "removed",
			 * чтобы бэкенд понял, что файл нужно отвязать.
			 * lecacy
			 *
			 * @param {HTMLElement} inp - Кнопка удаления (span.del), по которой кликнули.
			 */
			delete(inp) {
				var tr;
				if (typeof protocolsAction !== 'undefined') { // замена протоколов
					tr = findParentByClassName(inp, 'sf_container');
				}

				var lotParent = findParentByClassName(inp, 'gray-block');
				var lotNumber = $(lotParent).attr("data-lotnum");

				var attfile = findParentByClassName(inp, 'attfile');

				if (typeof fileDelMod !== 'undefined') { // editCompetitions1
					fileDelMod(attfile);
				}

				if ($(attfile).hasClass("new")) {
					var filelist = findParentByClassName(inp, 'filelist');
					$(attfile).remove();
					UI_Layer.reindex(filelist);
				} else {
					$("input[type=hidden]", attfile).val('');
					$(attfile).addClass('removed');
				}
				photoLoaded(lotNumber);

				if (window?.FUNCS?.DKP_Docs) { // дкп в черновиках торгов
					window.FUNCS.DKP_Docs.collectSelectedCats();
				}

				if (tr) {
					protocolsAction(tr);
				}

				if (typeof fileAfterDelete !== 'undefined') {
					fileAfterDelete(attfile);
				}
			},

			/**
			 * Обработчик клика на кнопку "Загрузить".
			 * Если пользователь уже ознакомлен с требованиями (или кнопка имеет data-skip-fileinfo),
			 * сразу открывает диалог выбора файлов. Иначе показывает модальное окно с требованиями.
			 * lecacy
			 *
			 * @param {HTMLElement} btn - Кнопка, по которой кликнули.
			 * @param {Event} event - Событие клика.
			 * @returns {boolean|undefined} false для предотвращения дефолтного поведения.
			 */
			open(btn, event) {
				event.stopPropagation();
				event.preventDefault();
				const parent = $(btn).parents('.fileform');
				if (localStorage.getItem('loadFileAcceptHide') || $(btn).attr("data-skip-fileinfo")) {
					$("input[type=file]", parent).val('').click();
					return;
				}
				MoK.showFileAccept(parent);
				return false;
			},

			/**
			 * Обработчик входа перетаскиваемого файла в зону загрузки.
			 * Добавляет класс "drag" для визуальной подсветки зоны.
			 * @param {HTMLElement} filebody - Зона загрузки (.filebody).
			 * @param {DragEvent} e - Событие dragenter.
			 */
			dragEnter(filebody, e) {
				e.preventDefault();
				$(filebody).addClass("drag");
			},

			/**
			 * Обработчик выхода перетаскиваемого файла из зоны загрузки.
			 * Убирает класс "drag".
			 * @param {HTMLElement} filebody - Зона загрузки (.filebody).
			 * @param {DragEvent} e - Событие dragleave.
			 */
			dragExit(filebody, e) {
				e.preventDefault();
				$(filebody).removeClass("drag");
			},

			/**
			 * Обработчик сброса файлов в зону загрузки (Drop).
			 * Извлекает файлы из dataTransfer и передает их в fileChange.
			 * @param {HTMLElement} filebody - Зона загрузки (.filebody).
			 * @param {DragEvent} e - Событие drop.
			 */
			drop(filebody, e) {
				e.preventDefault();
				e.stopPropagation(); // Важно: останавливаем всплытие
				$(filebody).removeClass("drag");
				var inp = $("input[type=file]", filebody)[0];

				var files = [];

				// более надёжный и универсальный API
				if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
					for (var i = 0; i < e.dataTransfer.files.length; i++) {
						files.push(e.dataTransfer.files[i]);
					}
				}
				// Fallback для dataTransfer.items (если files не доступен)
				else if (e.dataTransfer.items) {
					for (var i = 0; i < e.dataTransfer.items.length; i++) {
						if (e.dataTransfer.items[i].kind === 'file') {
							var file = e.dataTransfer.items[i].getAsFile();
							if (file)
								files.push(file);
						}
					}
				}

				if (files.length > 0) {
					// Определяем тип загрузки по классам контейнера
					var isImg = $(filebody).find('.filelist').hasClass('imglist');
					var isPdf = $(filebody).find('.filelist').hasClass('pdflist');

					Forms_Layer.change(inp, isImg || isPdf, false, files);
				}

				return false;
			},

			/**
			* Для документов, требующих цифровой подписи. Все файлы отправляются в одном запросе, подпись делается до отправки. (ГосКлюч или криптопро)
			*
			* @param {HTMLInputElement} inp - Input[type=file].
			* @param {boolean} isImg - Если true, файлы добавляются как картинки (через fileAddImgArray).
			* @param {boolean} doSign - Если true, файлы будут подписаны ЭП перед отправкой.
			* @param {FileList|Array<File>} [dropFiles] - Если файлы пришли через Drag-and-Drop, они передаются здесь.
			*/
			async change(inp, isImg, doSign, dropFiles) {
				if (inp.value == "") {
					return false;
				}

				if (Forms_Layer.isMaxFiles(inp)) {
					return false;
				}

				var fileform = findParentByClassName(inp, 'fileform');
				var el = $(".filelist", fileform)[0];

				const sf_container = findParentByClassName(inp, 'sf_container');
				const lazy_sign = $(sf_container).hasClass("lazy_sign");

				var data = new FormData();
				if ($(inp).attr("data-image") === "") {
					data.append("img", "true");
				}

				var bar = $(".prg", fileform);
				var percent = $(".prc", fileform);

				bar.show().width(0);
				percent.show();

				var files = typeof dropFiles === 'object' ? dropFiles : inp.files;
				if (!files && files.length == 0) {
					return false;
				}

				var accept = inp.accept;
				if (!accept) {
					//chrome fix
					accept = $(inp).attr('accept');
				}

				accept = accept.toLowerCase().replace(/\./g, "").replace(/\ /g, "").split(",");

				let fullSize = 0;

				for (var key = 0; key < files.length; key++) {
					var value = files[key];
					var ext = value.name.split(".").pop().toLowerCase();

					if (accept.indexOf(ext) === -1 && accept[0] !== "*") {
						aAlert("Недопустимый тип файла - '" + value.name + "'!");
						return false;
					}

					if (typeof (value.size) === "number") {
						fullSize += value.size;
					}

					if (value.size > (CONFIG.MAX_FILE_SIZE_MB * 1024 * 1024)) {
						aAlert("Размер файла должен быть не больше " + CONFIG.MAX_FILE_SIZE_MB + " Мб!");
						return false;
					}
					data.append(key, value);
				}

				if (fullSize >= 52428800) {
					aAlert("Размер загружаемых файлов (за раз) должен быть менее 50 Мб! Разделите загрузку файлов на несколько частей");
					return false;
				}


				if (lazy_sign) {
					const lazy_data = [];
					data.forEach(function (item) {
						if (item instanceof File) {
							const lazy_item = { size: item.size, success: true, name: item.name, orig_name: item.name };
							lazy_data.push(lazy_item);
						}
					});

					fileAddArray(lazy_data, el);
					if (typeof protocolsAction !== 'undefined') { // замена протоколов
						const tr = findParentByClassName(inp, 'sf_container');
						if (tr) {
							protocolsAction(tr);
						}
					}
					return true;
				}


				/**
				 * Срабатывает когда загружаем новый файл
				 */
				async function post() {
					inp.value = "";
					var file_counter = 0;
					var name = null;
					var lastModified = 0;
					var type = "";
					var total_size = 0;

					data.forEach(function (item) {
						if (item instanceof File) {
							file_counter++;
							total_size += item.size;
							if (file_counter === 1) {
								name = item.name;
								type = item.type;
							} else {
								name = file_counter + " файла(ов)";
								type = null;
							}

						}
					});

					var file = {
						"name": name,
						"type": type,
						"size": total_size,
						"lastModified": lastModified
					};
					var upload_file_idx = UPLOAD_FILS.push(file, inp);
					return new Promise((resolve, reject) => {
						jQuery.ajax({
							url: 'fileUpload',
							type: 'POST', // важно!
							data: data, // информация о подписи
							cache: false,
							dataType: 'html',
							// отключаем обработку передаваемых данных, пусть передаются как есть
							processData: false,
							// отключаем установку заголовка типа запроса. Так jQuery скажет серверу что это строковой запрос
							contentType: false,
							// функция успешного ответа сервера
							success: function (respond, status, jqXHR) {
								UPLOAD_FILS.done(upload_file_idx);
								bar.hide();
								percent.hide();
								const data = JSON.parse(respond); // если ошибка с подписью, то только один элемент в массиве, вне зависимости от количества подписываемых файлов

								if (PARAMS.file_uploads_hashes) {
									// Проверка дубликатов hid для каждого файла в ответе
									for (var i = 0; i < data.length; i++) {
										var itemHid = data[i]?.hid;
										if (itemHid && $(".attfile input[data-type='hid'][value='" + itemHid + "']", el).length > 0) {
											aAlert("Файл \"" + data[i].name + "\" уже был ранее загружен!");
											return; // Прерываем обработку всего ответа
										}
									}
								}



								if (isImg) {
									fileAddImgArray(data, el);
								} else {
									fileAddArray(data, el);
								}


								if (typeof fileOnload === "function") {
									fileOnload(data, el);
								}

								if (data && data.length === 1) {
									if (!data[0].success) {
										clearStoredCertificate(); // сбрасываем сертификат, если ошибка
									}
								}

								if (data && data[0].success) { //  если нет ошибки с подписью (проверяем только по первому элементу, так как можно загрузить только один + если ошибка то тоже один будет)
									if (window?.FUNCS?.DKP_Docs) { // очистка блоков с шаблонами в newComp
										const trDKP = findParentByClassName(inp, 'signfile_dog_kupprod');
										if (trDKP) {
											window.FUNCS.DKP_Docs.output.empty(); // удаляем блок с шаблонами
										}
									}
									if (typeof protocolsAction !== 'undefined' && data[0].success) { // замена протоколов
										const tr = findParentByClassName(inp, 'sf_container');
										if (tr) {
											protocolsAction(tr);
										}
									}
								}
								resolve(true);
							},
							// функция ошибки ответа сервера
							error: function (jqXHR, status, errorThrown) {
								UPLOAD_FILS.error(upload_file_idx);
								bar.hide();
								percent.hide();
								console.log('ОШИБКА AJAX запроса: ' + status, jqXHR);
								aAlert("Ошибка загрузки файла!");
								resolve(false);
							},

							xhr: function () {
								var myXhr = $.ajaxSettings.xhr();
								if (myXhr.upload) {
									// For handling the progress of the upload
									myXhr.upload.addEventListener('progress', function (e) {
										if (e.lengthComputable) {
											UPLOAD_FILS.progress(upload_file_idx, e);
											var percentComplete = Math.round(e.loaded / e.total * 100);
											var percentVal = percentComplete + '%';
											bar.width(percentVal);
											percent.html('Загрузка ' + percentComplete + '%...');
											//							console.log("PROGRESS", e, percentComplete, bar, percent);
										}
									}, false);
								}
								return myXhr;
							}

						});
					});
				}


				if (doSign && !lazy_sign) {
					var files = inp.files; // FileList object

					if (await checkGosKey()) {
						//Подпись файлов через ГосКлюч
						for (var i = 0; i < files.length; i++) {
							var fileInfo = getFileInfoFromName(files[i].name);
							if (!fileInfo.gosKeyAllowed) {
								await aAlert("Подписание данного типа документа не поддерживается Госключем!<br>Поддерживаемые типы: " + PARAMS.goskey_allowed_ext.join(", "));
								return;
							}
							if (fileInfo.fileExtChange && !await aConfirm("Госключ не поддерживает корректное отображение документов данного формата. При подписи в приложении может некорректно отображаться предпросмотр документа.", "Ознакомлен, продолжить подписание")) {
								return;
							}
						}

						//Все загрузилось, отправляем на подпись
						SignGosKeyFiles(files, function (signData) {
							for (var i = 0; i < files.length; i++) {
								var filename = files[i].name.toGoskeyFileName();//.replaceAll(/ /gi, "_");
								data.append("sign" + i, signData[filename]);
							}
							post();
						});

						return;
					}
					var useSelected = true;
					for (var fn = 0; fn < files.length; fn++) {
						console.log("processing file ", fn);
						var file = files[fn];
						const str = await readFile(file);
						const sign = await Sign(str, true, false, null, useSelected);
						useSelected = true;
						if (sign) {
							data.append("sign" + fn, sign);
						} else {
							return false;
						}
					}
				}
				return post();

				// AJAX запрос
			},

		};


		return {
			transport: Transport_Layer,
			queue: Queue_Layer,
			ui: UI_Layer,
			forms: Forms_Layer,
			config: CONFIG
		}
	})();

	// то, что будет доступно снаружи
	const publicAPI = {
		...FileHelpers,
		...FileUploadKit, // - нужно доработать
		...videoHelpers,
	};

	return publicAPI;
})();
